import { useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectInput from '../../../../Core/Fields/SelectInput';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab1 = ({ supplier, setSelectedSupplier, selectedSupplier, setSuppliergrpname, supplirGrpname, selectedpayment, setIsGroup, isGroup, setSelectedpayment }) => {


    const dummydata = [
        { label: 'Test1', value: 'google' },
        { label: 'Test2', value: 'amazon' },
        { label: 'Test3', value: 'microsoft' },
    ];


    return (
        <div>
      <div className="px-4 py-4" style={{ background: 'white' }}>
        <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >
          <div className="col-md-12" style={{ display: 'flex' }} >

            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <Input
                    id="BrandName"
                    label="Supplier Group Name"
                    style={{ height: "30px" }}
                    value={supplirGrpname}
                    onChange={(e) => setSuppliergrpname(e.target.value)}
                    readOnly
                  />
                </div>
                <div style={{ flex: 1 }}>
                     <Input
                     label="Parent Supplier Group"
                    style={{ height: "30px" }}
                    value={selectedSupplier}
                    readOnly
                  />
                  
                </div>
                <div style={{ flex: 1 }}>
                    <Input
                     label="Default Payment Terms Template"
                    style={{ height: "30px" }}
                    value={selectedpayment}
                    readOnly
                  />
                  
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                  <Checkbox
                    id="isGroup"
                    label="isGroup"
                    Checked={true}
                    value={isGroup === 1}
                    disabled={true}
                  />

                </div>
              </div>


            </div>


          </div>
        </div>


      </div>

    </div>
    )
}

export default Tab1